import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

export default function BlogPage() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await fetch(`https://uk6bp6sqk2dwto7mcbg7qgibmm0dckho.lambda-url.us-east-1.on.aws/get-blog/${id}`);
        if (!response.ok) throw new Error("Blog not found");

        const data = await response.json();
        setBlog(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {loading && <p className="text-gray-600 text-center">Loading...</p>}
      {error && <p className="text-red-500 text-center">{error}</p>}

      {blog && (
        <div className="max-w-3xl mx-auto bg-white p-6 shadow-lg rounded-lg">
          <h1 className="text-3xl font-bold text-gray-800">{blog.title}</h1>
          <div 
                dangerouslySetInnerHTML={{ __html: blog.content }} 
                className="text-gray-600 mt-2"
              ></div>
          <p className="text-sm text-gray-500 mt-3">By {blog.author}</p>
          <Link to="/" className="text-blue-500 mt-4 inline-block">← Back to Blogs</Link>
        </div>
      )}
    </div>
  );
}
